// FORMAT PHONE NUMBER TO E.164 FOR STORAGE
import { parsePhone } from './parsePhone';

// CONVERT ANY PHONE FORMAT TO E.164 (e.g., "+14155551234")
// RETURNS NULL IF UNABLE TO PARSE
//
// `country` IS THE ASSUMPTION FOR INPUT WITHOUT A LEADING "+" (CU-86ajrx60c).
// OMITTING IT KEEPS THE EXISTING US DEFAULT.
export const formatPhoneE164 = (
  value: string | null | undefined,
  country?: string | null,
): string | null => {
  // `undefined` FALLS THROUGH TO parsePhone'S OWN DEFAULT, SO OMITTING THE
  // ARGUMENT AND PASSING undefined ARE THE SAME CALL.
  const parsed = parsePhone(value, country);

  if (parsed && parsed.isValid) {
    return parsed.e164;
  }

  return null;
};
